import type {Optional} from '@yandex-delivery/types'

import type {DeliveryInterval, LikeDeliveryInterval} from 'src/shared/types'

/**
 * Проверяет, что интервал входит в список интервалов доставки
 * @param deliveryIntervals
 * @param interval
 */
function includesInterval(deliveryIntervals: DeliveryInterval[], interval?: LikeDeliveryInterval): boolean {
  if (interval === undefined) {
    return false
  }

  const foundInterval = deliveryIntervals.find(deliveryInterval => {
    return deliveryInterval.from === interval.from && deliveryInterval.to === interval.to
  })

  return Boolean(foundInterval)
}

/**
 * Возвращает интервал доставки, если он корректен, иначе возвращает undefined
 * @param deliveryIntervals - Все интервалы доставки
 * @param interval - Любой похожий на интервал объект
 */
export function withCorrectDeliveryInterval(
  deliveryIntervals: DeliveryInterval[],
  interval?: DeliveryInterval,
): Optional<DeliveryInterval> {
  if (deliveryIntervals.length === 0) {
    return undefined
  }

  if (includesInterval(deliveryIntervals, interval)) {
    return interval
  }

  const [firstInterval] = deliveryIntervals

  return firstInterval
}
